<script setup lang="ts">
import { onMounted, toRefs,watch,reactive, ref, computed } from "vue";
import { errorAlert } from "../plugins/alert";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  LineController,
  PointElement,
  RadialLinearScale,
  Filler,
  ArcElement,
  LineElement
} from 'chart.js'
import { Radar,Pie,Bar,Line } from 'vue-chartjs';
import ChartDataLabels from 'chartjs-plugin-datalabels';

ChartJS.register(CategoryScale, LinearScale, BarElement,PointElement ,RadialLinearScale, LineElement, ArcElement, LineController, ChartDataLabels, Filler, Title, Tooltip, Legend)

const props = defineProps({
    chartType: {
      type:String,
      required:true
    },
    chartData: {
      type:Object,
      required:true
    },
    chartOptions: {
      type:Object,
      default:() => {
        return null;
      }
    },
    dataLabels: {
      type:Object,
      default:() => {
        return null;
      }
    },
    height: {
      type:String,
      default: () => {
        return '';
      }
    }
})
const { chartData } = toRefs(props);
const options:ChartOptions = {
  responsive: true,
  maintainAspectRatio: false,
};
options.plugins = {
        datalabels: {
          formatter: function(value, context) {
              return ''; // デフォルトは値を表示しない
          },
          font: {
            weight: 'bold',
            size: 16,
          }
      }
}
if (props.chartOptions != null) {
  for (let key in props.chartOptions) {
    options[key] = props.chartOptions[key];
  }
}
if (props.dataLabels) {
  options['plugins']['datalabels'] = props.dataLabels;
}

const chartDataList = reactive([]);

watch(chartData,(newValue,oldValue) => {
  chartDataList.splice(0);
  chartDataList.push(newValue);
},{deep:true});

onMounted(() => {
  chartDataList.splice(0);
  chartDataList.push(props.chartData);
});
</script>

<style scoped lang='sass'>
</style>

<template>
<div>
  <div v-for="(chartRecord,index) in chartDataList" :key="index">
    <div v-if="chartType == 'radar'" :style="(height.length > 0 ? 'height:' + height : '')">
      <Radar :data="chartRecord" :options="options"/>
    </div>
    <div v-else-if="chartType == 'pie'" :style="(height.length > 0 ? 'height:' + height : '')">
      <Pie :data="chartRecord" :options="options"/>
    </div>
    <div v-else-if="chartType == 'bar'" :style="(height.length > 0 ? 'height:' + height : '')">
      <Bar :data="chartRecord" :options="options"/>
    </div>
    <div v-else-if="chartType == 'line'" :style="(height.length > 0 ? 'height:' + height : '')">
      <Line :data="chartRecord" :options="options"/>
    </div>
  </div>
</div>
</template>

